export default __webpack_public_path__ + "static/media/logo3.64784533.png";